import { LumoraClient, LUMORA_PROD_API_BASE_URL, localStorageTokens } from "@lumora/bridge";
/** Reads `import.meta.env` when the bundler provides it; empty otherwise (tests, SSR). */
export function readSiteEnv() {
    return (import.meta.env ?? {});
}
export function resolveSiteSlug(defaultSlug, env = readSiteEnv()) {
    return env.VITE_LUMORA_SITE?.trim() || defaultSlug;
}
/**
 * API origin from the site's Vite env bag (values come from `.env*`).
 * Missing/empty → production. No hostnames are hardcoded here.
 */
export function resolveSiteApiBase(env = readSiteEnv()) {
    const raw = String(env.VITE_LUMORA_API ?? "").trim();
    return (raw || LUMORA_PROD_API_BASE_URL).replace(/\/+$/, "");
}
/** Owner/staff JWTs persist across reloads (Connect+). Harmless on Spark/Brand. */
export function createSiteClient(slug, env = readSiteEnv()) {
    return new LumoraClient({
        baseUrl: resolveSiteApiBase(env),
        ...localStorageTokens(`lumora.${slug}.tokens`),
    });
}
//# sourceMappingURL=client.js.map